import React from 'react';
import {Button, withStyles} from '@material-ui/core';
import { Link } from 'react-router-dom';
import SaveButtonWithoutIcon from '../../components/SaveButtonWithoutIcon';
import ToolbarButtonsStyles from '../../components/ToolbarButtonsStyles';
import StyledToolbar from '../../components/StyledToolbar';

const CustomToolbar = props => {
  const {classes, onSubmit, solutionID, ...rest} = props;
  const encodedURI = encodeURIComponent(solutionID);
  return (
    <StyledToolbar {...rest}>
      <Button
        className={`${classes.button} ${classes.cancelButton}`}
        component={Link}
        to={`/universal_consent_solutions/${encodedURI}`}
      >
        cancel
      </Button>
      <SaveButtonWithoutIcon
        color="secondary"
        className={`${classes.button} ${classes.saveButton}`}
        label="next"
        onSave={onSubmit}
        submitOnEnter={true}
        disabled={rest.invalid }
      />
    </StyledToolbar>
  )
}

export default withStyles(ToolbarButtonsStyles)(CustomToolbar)
